// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_HL5F {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.H0_DaP {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-paragraph-md-font-size);
  line-height: var(--type-paragraph-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  width: 100%;
}

.D9Twcc {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.hC7kgc {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: var(--spacing-2);
  width: 100%;
  padding: var(--spacing-4) 0 0 0;
}

.M8RlEG {
  height: var(--submit-height);
  width: 100px;
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--surface-neutral-white);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-primary-medium);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
  transition: var(--transition-color);
}

.M8RlEG:hover {
  background: var(--surface-neutral-pale);
}

.lSylWn {
  height: var(--submit-height);
  width: 100px;
  padding: var(--spacing-1) var(--spacing-1-5);
  border-radius: var(--button-border-radius);
  background: var(--brand-tr-orange);
  border: 2px solid var(--brand-tr-orange);
  color: var(--text-neutral-white);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  cursor: pointer;
  transition: var(--transition-color);
}

.lSylWn:hover:not(:disabled) {
  background: var(--surface-primary-strong);
  border-color: var(--surface-primary-strong);
}

.lSylWn:disabled {
  opacity: var(--opacity-0-5);
  cursor: not-allowed;
  background: var(--disabled-subtle-surface);
  color: var(--disabled-subtle-text);
  border: 2px solid var(--disabled-subtle-surface);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeyInput/PixKeyInput.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,6CAA6C;EAC7C,iDAAiD;EACjD,+BAA+B;EAC/B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4CAA4C;EAC5C,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,iCAAiC;EACjC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4CAA4C;EAC5C,0CAA0C;EAC1C,kCAAkC;EAClC,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;EAClC,gDAAgD;AAClD","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.stepTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--type-paragraph-md-font-size);\n  line-height: var(--type-paragraph-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  width: 100%;\n}\n\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--spacing-2);\n  width: 100%;\n  padding: var(--spacing-4) 0 0 0;\n}\n\n.backButton {\n  height: var(--submit-height);\n  width: 100px;\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--surface-neutral-white);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-primary-medium);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n  transition: var(--transition-color);\n}\n\n.backButton:hover {\n  background: var(--surface-neutral-pale);\n}\n\n.nextButton {\n  height: var(--submit-height);\n  width: 100px;\n  padding: var(--spacing-1) var(--spacing-1-5);\n  border-radius: var(--button-border-radius);\n  background: var(--brand-tr-orange);\n  border: 2px solid var(--brand-tr-orange);\n  color: var(--text-neutral-white);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  cursor: pointer;\n  transition: var(--transition-color);\n}\n\n.nextButton:hover:not(:disabled) {\n  background: var(--surface-primary-strong);\n  border-color: var(--surface-primary-strong);\n}\n\n.nextButton:disabled {\n  opacity: var(--opacity-0-5);\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface);\n  color: var(--disabled-subtle-text);\n  border: 2px solid var(--disabled-subtle-surface);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `G_HL5F`,
	"stepTitle": `H0_DaP`,
	"inputContainer": `D9Twcc`,
	"buttonsContainer": `hC7kgc`,
	"backButton": `M8RlEG`,
	"nextButton": `lSylWn`
};
module.exports = ___CSS_LOADER_EXPORT___;
